// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"317":"c350e130","710":"047418c3"}[chunkId] + ".chunk.css";
};